import { createSelector } from 'reselect'

import { selectPlanningWizardState } from './selectPlanningWizardState'

export const selectWizardIsLoading = createSelector(
  [selectPlanningWizardState],
  (planningWizard) => planningWizard.isLoading
)
